import { Calendar2, type Icon } from 'react-bootstrap-icons';

import { DateParser } from '../../utils';

interface StatsCardProps {
  title: string;
  subtitle?: string;
  valueDate?: Date;
  type: 'number' | 'date' | 'text';
  value: number | string | Date | undefined;
  icon?: Icon;
  iconColor?: string;
  /**
   * 'centered' (default) keeps the legacy vertically-centered group.
   * 'title-top' pins the title to the top of the card and keeps the
   * icon vertically centered regardless of the value length.
   */
  layout?: 'centered' | 'title-top';
}

const StatsCard = ({
  title,
  subtitle,
  value,
  valueDate,
  type,
  icon: IconComponent,
  iconColor,
  layout = 'centered'
}: StatsCardProps) => {
  const formatValue = (
    type: 'number' | 'date' | 'text',
    value: number | string | Date | undefined
  ): string => {
    if (value == null || value == undefined) {
      return '';
    }

    switch (type) {
      case 'date':
        return DateParser.toDateTimeString(new Date(value));
      case 'number':
        return Number(value).toLocaleString();

      case 'text':
        return String(value);

      default:
        return String(value);
    }
  };

  const titleTop = layout === 'title-top';

  return (
    <div className="card h-100">
      <div className={`card-body d-flex ${titleTop ? '' : 'align-items-center'} py-4 px-3`}>
        <div
          className={
            titleTop
              ? 'd-flex align-self-stretch gap-3'
              : 'd-flex align-items-center gap-3 mb-4 mt-auto'
          }>
          {IconComponent && (
            <div className={`fs-2 text-primary ${titleTop ? 'align-self-center' : ''}`}>
              <IconComponent
                size={35}
                style={{
                  ...(iconColor != null && { color: iconColor })
                }}
              />
            </div>
          )}
          <div className="w-100">
            <div className="text-uppercase text-muted fw-semibold small mb-2">{title}</div>
            {subtitle && (
              <div className="text-uppercase text-muted fs-5 fw-semibold small mb-2">
                {subtitle}
              </div>
            )}

            <div
              className={`fw-bold text-dark ${type === 'number' ? 'text-end' : ''}`}
              style={{ fontSize: '1.5rem' }}>
              {formatValue(type, value)}
            </div>
            {valueDate && (
              <div className="mt-3">
                <Calendar2 className="me-2" />
                {DateParser.toDateTimeString(valueDate)}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export { StatsCard };
